import React, { useEffect, useMemo, useState } from 'react';
import RuntimeConfigGridToolbar from './RuntimeConfigGridToolbar';
import RuntimeConfigGridPagination from './RuntimeConfigGridPagination';
import { BROWSE_PAGE_SIZE } from './runtimeConfigUtils';

const CorsGrid = ({ document, onEdit, onRemove, disabled }) => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);

  const domains = document?.data?.domains || [];

  useEffect(() => {
    setPage(0);
  }, [document]);

  const filtered = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) {
      return domains;
    }
    return domains.filter((row) => {
      const pattern = row.pattern?.toLowerCase() || '';
      const category = row.category?.toLowerCase() || '';
      return pattern.includes(term) || category.includes(term);
    });
  }, [domains, search]);

  const start = page * BROWSE_PAGE_SIZE;
  const pageRows = filtered.slice(start, start + BROWSE_PAGE_SIZE);

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(0);
  };

  if (!document) {
    return null;
  }

  return (
    <div className="runtime-config-grid-section" data-testid="cors-grid">
      <RuntimeConfigGridToolbar
        label="Filter CORS entries"
        placeholder="Search pattern or category…"
        value={search}
        onChange={handleSearchChange}
        testId="cors-search"
      />

      <table className="runtime-config-table">
        <thead>
          <tr>
            <th scope="col">Pattern</th>
            <th scope="col">Category</th>
            <th scope="col">Enabled</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {pageRows.length === 0 ? (
            <tr>
              <td colSpan="4" className="runtime-config-empty">No CORS entries found.</td>
            </tr>
          ) : (
            pageRows.map((row) => (
              <tr key={row.pattern}>
                <td>{row.pattern}</td>
                <td>{row.category || '—'}</td>
                <td>{row.enabled === false ? 'No' : 'Yes'}</td>
                <td>
                  <button
                    type="button"
                    className="runtime-config-row-btn"
                    disabled={disabled}
                    aria-label={`Edit CORS pattern ${row.pattern}`}
                    onClick={() => onEdit({
                      isEdit: true,
                      editKey: row.pattern,
                      action: 'merge',
                      formState: {
                        pattern: row.pattern,
                        category: row.category || '',
                        enabled: row.enabled !== false,
                      },
                    })}
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    className="runtime-config-row-btn runtime-config-row-btn-danger"
                    disabled={disabled}
                    aria-label={`Remove CORS pattern ${row.pattern}`}
                    onClick={() => onRemove({ pattern: row.pattern })}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <RuntimeConfigGridPagination
        count={filtered.length}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
      />
    </div>
  );
};

export default CorsGrid;
